const nunca_frequentou = {
  path: "/nunca-frequentou",
  redirect: "/nunca-frequentou",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Manutenção de Matrículas",
  },
  children: [
    {
      path: "/nunca-frequentou",
      name: "nunca-frequentou",
      component: () => import("@/views/NuncaFrequentou/NuncaFrequentou.vue"),
    },
  ],
};
export { nunca_frequentou };
